<template>
  <div class="resultsGroup">
    <div class="resultsGroup__loading" v-if="isPageLoading">
      <adx-loading-primary/>
    </div>
    <div v-if="!isPageLoading">
      <div class="resultsGroup__top">
        <div class="resultsGroup__top__header">
            <div class="resultsGroup__top__header__subtitle subhead">
            Showing result for :
            </div>
            <h1 class="resultsGroup__top__header__title large-title">
            “{{this.searchValue}}”
            </h1>
            <p v-if="status != `400`" class="resultsGroup__top__header__total">
            Total listing {{totalListing}} items
            </p>
        </div>
        <div v-if="selectedQuickFilterValue != 'ALL' && status != `400`" class="resultsGroup__top__filter">
            <div class="resultsGroup__top__filter__left">
            <template v-if="selectedQuickFilterValue == 'lifestyle'">
                <adx-dropdown-search @selected="selectedLocation" :list="locations"
                labelButton="Locations" :selected-value="selectedLocationValue"/>
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
                <adx-dropdown-checkbox @selected="selectedSocial"
                :list="social"
                :color="'pink'"
                labelButton="Social"
                :title="`Social`" :default="selectedSocialValue" />
                <adx-dropdown-checkbox @selected="selectedProfile"
                :list="profile"
                :color="'pink'"
                labelButton="Profile"
                :title="`Profile`" :default="selectedProfileValue" />
            </template>
            <template v-else-if="selectedQuickFilterValue == 'malls'">
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
            </template>
            <template v-else-if="selectedQuickFilterValue == 'spbu'">
                <adx-dropdown-checkbox @selected="selectedSurrounding"
                :list="surroundings"
                :color="'pink'"
                labelButton="Surrounding"
                :title="`Surrounding`" :default="selectedSurroundingValue" />
            </template>
            <template v-else-if="selectedQuickFilterValue == 'airport'">
                <adx-dropdown-search @selected="selectedLocation" :list="locations"
                labelButton="Locations" :selected-value="selectedLocationValue"/>
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
            </template>
            <template v-else-if="selectedQuickFilterValue == 'airlines'">
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
                <adx-dropdown-checkbox @selected="selectedSocial"
                :list="social"
                :color="'pink'"
                labelButton="Social"
                :title="`Social`" :default="selectedSocialValue" />
            </template>
            <div class="resultsGroup__top__filter__left__sort--mobile">
                <button class="btn-regular" :class="[labelType == 'Type' ? 'secondary' : 'pink']" @click="showQuickFilter = true">{{labelType | capitalizing}}</button>
            </div>
            <div v-if="filtered" class="reset">
                <button class="btn-regular link" @click="resetFilter">Reset</button>
            </div>
            </div>
            <div class="resultsGroup__top__filter__right">
            <span class="subhead">Sort by :</span>
            <div>
                <adx-dropdown-sort id="sort_1" :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sortOptions" />
            </div>
            </div>
        </div>
        <div class="resultsGroup__top__filterDefault" v-else>
        <div class="resultsGroup__top__filterDefault__right">
          <span class="subhead">Sort by :</span>
          <div>
              <adx-dropdown-sort id="sort_2" :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sortOptions" />
          </div>
        </div>
        </div>
      </div>
      <template v-if="status == `400`">
            <div class="resultsGroup__middle__alert">
            <p class="subhead">We didn’t find any match for : <b>“{{this.searchValue}}”</b></p>
            <p class="subhead"><b> Tips :</b> Keep calm hope we can add this name in the future. :) • Try checking your spelling or use more general terms</p>
            </div>
            <div class="resultsGroup__middle__maybe">
                <h6 class="subhead">Maybe you want check our interesting location :</h6>
            </div>
        </template>
      <div class="resultsGroup__bottom">
        <div class="resultsGroup__bottom__content">
            <div class="resultsGroup__bottom__content__listings" v-if="!isSubLoading">
                <template>
                    <adx-list-result @goToDetail="gotoDetail" :data='itemsCategory' :category="selectedQuickName"
                    @createNew="createNew"
                    @createNewCampaign="createNewCampaign" :isAction="true"
                    :menuList="expansionList" :loading="isSubLoading">
                        <template slot="loading" v-if="!isPageLoading || !isSubLoading">
                        <template v-if="!isLoading">
                            <div v-if="next" class="resultsGroup__bottom__content__listings__paging" @click.stop="loadInfiniteData">
                                <!-- <span class="resultsGroup__bottom__content__listings__paging__load">Show more</span> -->
                                <button class="btn-regular secondary"> <strong>Load More</strong> </button>
                            </div>
                            <div v-else class="resultsGroup__bottom__content__listings__paging">
                                <span class="resultsGroup__bottom__content__listings__paging__empty"> There is no more data </span>
                            </div>
                        </template>
                        <template v-else>
                            <adx-loading-primary />
                        </template>
                        </template>
                    </adx-list-result>
                </template>
            </div>
            <div class="resultsGroup__bottom__content__filter" v-if="!isSubLoading">
                <adx-quick-filter :list="quickFilter" :value.sync="selectedQuickFilterValue"
                @valueClicked="selectCategory"
                :defaultOpen="selectedQuickFilterValue"/>
            </div>
            <div class="resultsGroup__bottom__content__loadingBottom" v-if="isSubLoading">
            <adx-loading-primary />
            </div>
        </div>
        <!-- <template v-else>
          <div class="resultsGroup__bottom__content">
          
          </div>
        </template> -->
      </div>
      <adx-modal v-if="showQuickFilter" title="Type" @modal-close="showQuickFilter = false">
        <div slot="content" class="content">
          <div class="resultsGroup__type">
            <ul>
              <li v-for="(item, index) in quickFilter" :key="index">
                <div class="resultsGroup__type__content subhead" @click.stop="selectType(item, index)">
                  {{item.label.charAt(0).toUpperCase() + item.label.substr(1)}}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="toggleModalCreate" type='small' :noTitle="true">
        <div class="resultsGroup__modal" slot="content">
          <div class="resultsGroup__modal__input">
            <input ref="input" type="text" @keyup="KeyUp">
            <label class="subhead">Folder Name</label>
          </div>
          <div class="resultsGroup__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCreate">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createFolder">Save</button>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
        <div class="resultsGroup__modal" slot="content">
          <div class="resultsGroup__modal__input">
            <input ref="input" type="text" @keyup="KeyUpCampaign">
            <label class="subhead">Campaign Name</label>
          </div>
          <div class="resultsGroup__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createCampaign">Save</button>
          </div>
        </div>
      </adx-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ListGroup from '@/views/Search/ResultsGroup/ListGroup'
import ListResult from '@/views/Search/ResultsGroup/ListResult'
import QuickFilter from '@/components/QuickFilter'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdownCustom'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import InfiniteLoading from 'vue-infinite-loading'
import ExpandableResult from '@/components/ExpandableListItems'
import Modal from '@/components/Modal'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { fromKeys, mapListFilter } from '@/lib/transformer'
import { discoveryParams } from '@/api/params'
import types from '@/lib/types'
import LoadingPrimary from '@/components/Loading/Primary'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-results-group',
  components: {
    'adx-list-group': ListGroup,
    'adx-list': ListResult,
    'adx-quick-filter': QuickFilter,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-sort': DropdownSort,
    'adx-list-result': ExpandableResult,
    'infinite-loading': InfiniteLoading,
    'adx-modal': Modal,
    'adx-loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      items: [],
      totalListing: 0,
      next: null,
      count: null,
      isLoading: false,
      page: 2,
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      searchValue: ``,
      quickFilter: [],
      selectedQuickFilterValue: `ALL`,
      itemsCategory: ``,
      status: ``,
      locations: [],
      sortOptions: [
        {
          id: 0,
          label: `Name`,
          value: `title`
        },
        {
          id: 1,
          label: `Traffic`,
          value: `-traffic`
        },
      ],
      selectedSortValue: `-traffic`,
      selectedLocationValue: '',
      brands: [],
      selectedBrandValue: [],
      social: [],
      selectedSocialValue: [],
      profile: [],
      selectedProfileValue: [],
      surroundings: [],
      selectedSurroundingValue: [],
      selectedTypeValue: '',
      selectedTypeName: '',
      selectedQuickName: '',
      showQuickFilter: false,
      isTypeExpand: [],
      labelType: 'Type',
      isPageLoading: false,
      isSubLoading: false,
      isCreateCampaign: false,
      isCreateSaved: false,
      createParams: {},
      newTitle: '',
      query: '',
      categories: [],
      expansionList: []
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort' && key !== 'category' &&
        key !== 'property_type' && key !== 'query' &&
        querys[key]) filtered = true
      });

      // if (
      //   this.selectedTypeValue ||
      //   this.selectedProfileValue.length ||
      //   this.selectedBrandValue.length ||
      //   this.selectedSocialValue.length ||
      //   this.selectedLocationValue
      // ) filtered = true

      return filtered
    },
    getFilterParams: function () {
      const params = {
        category: this.selectedQuickFilterValue === 'ALL' ? undefined : this.selectedQuickFilterValue,
        query: this.searchValue ? this.searchValue : undefined,
        sort: this.selectedSortValue || undefined,
        surrounding: this.selectedSurroundingValue.join(`,`) || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        brand: this.selectedBrandValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        cluster: this.selectedLocationValue || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    ...mapGetters ({
      token: 'token'
    }),
    getCategoryCode: function() {
      return {...discoveryParams[this.selectedQuickFilterValue]}
    }
  },
  watch: {
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.checkLoad()
      });
    },
    selectedQuickFilterValue: function (newValue, oldValue) {
      this.isSubLoading = true
      if (oldValue !== 'ALL') {
        this.resetSpecificFilter()
        this.$nextTick(() => {
          this.checkLoad()
        })
      } else {
        this.selectedSortValue = `-traffic`
        this.getFilter()
        this.$nextTick(() => {
          this.checkLoad()
        })
      }
    },
    searchValue: function() {
      this.$nextTick(() => {
        this.checkLoad()
      });
    }
  },
  beforeCreate() {

  },
  created() {
    this.getFilter()
    this.getCategories()
  },
  beforeMount() {
    this.loadSavedandCampaign()
  },
  mounted() {
    const query = this.$route.query
    if (query) {
      this.setFilterQuery(query)
      this.$nextTick(() => {
        // this.checkLoad()
        Vue.$broker.$on("app-search", this.newSearch.bind(this))
      })
    } else {
      // this.checkLoad()
      Vue.$broker.$on("app-search", this.newSearch.bind(this))
    }
  },
  beforeUpdate() {

  },
  updated() {
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectCategory(item) {
        this.selectedQuickFilterValue = item
    },
    loadSavedandCampaign() {
      while(this.expansionList.length > 0) {
        this.expansionList.pop()
      }
      this.expansionList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        const response = await api.get(apiV2.saved, { needToken: true })
        if (response.status === 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[0]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        }
      })();
    },
    loadCampaigns() {
      (async () => {
        const response = await api.get(apiV2.draftCampaigns, { needToken: true })
        if (response.status == 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[1]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        } else {
          // this.error = response.data.error
        }
      })();
    },
    createNewCampaign(params) {
      this.createParams = params
      this.isCreateCampaign = true
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.loadSavedandCampaign()
        }
      })();
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    createNew(params) {
      this.createParams = params
      this.isCreateSaved = true
    },
    toggleModalCreate() {
      this.isCreateSaved = !this.isCreateSaved
    },
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    newSearch(item) {
      this.resetFilter()
      this.searchValue = item
    },
    getSearch(item) {
      this.searchValue = item
    },
    selectType(item, index){
      this.showQuickFilter = false
      this.selectedQuickFilterValue = item.value
      this.labelType = item.label
    },
    checkLoad() {
      if(this.selectedQuickFilterValue == 'ALL'){
        this.resetSpecificFilter()
        this.loadCategory()
      }else {
        this.loadCategory()
      }
    },
    resetFilterOld() {
      this.selectedQuickFilterValue = 'ALL'
      this.selectedSortValue = undefined
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedSurroundingValue = []
      this.selectedLocationValue = undefined
      this.getFilterParams
    },
    resetSpecificFilter() {
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedSurroundingValue = []
      this.selectedLocationValue = undefined
      this.getFilterParams
      this.getFilter()
    },
    resetFilter() {
      this.selectedSurroundingValue = []
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedLocationValue = ''
      this.selectedSortValue = '-traffic'

      const params = {
        surrounding: undefined,
        profile: undefined,
        brand: undefined,
        social: undefined,
        cluster: undefined
      }
      this.$router.replace({
        query: params
      })
      this.getFilterParams
    },
    loadCategory() {
      (async () => {
        this.itemsCategory = []
        this.isSubLoading = true
        const searchValue = this.searchValue
        let params = {
          ...this.getFilterParams
        }
        const { data , status} = await api.get(apiV2.searchResult, { params })

        if (data) {
            this.itemsCategory = data.results || []
            this.count = data.count
            this.next = data.next
            this.totalListing = this.itemsCategory.length
        }
        this.page = 2
        this.isSubLoading = false
        this.status = status
        
      })();
    },
    async loadInfiniteData($state) {
      if (this.$data.next) {
        this.$data.isLoading = true
        let params = {
          page: this.$data.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.searchResult, { params })
        if (data.results) {
          this.$data.itemsCategory = this.$data.itemsCategory.concat(data.results)
          this.totalListing = this.$data.itemsCategory.length
          this.$data.count = data.count
          this.$data.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
        } else {
          // $state.complete()
        }
        this.$data.page += 1
        this.$data.isLoading = false
      }
    },
    getFilter() {
      (async () => {
        let categoryCode = this.getCategoryCode? this.getCategoryCode.category : undefined
        const { data } = await api.get(apiV2.searchFilter, {
          params: { category: categoryCode }
        })
        this.mapFilter(data)
      })();
    },
    getCategories() {
      let file = `/static/data/categories.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        this.categories = data.categories;
      })();
    },
    mapFilter(data) {
      const brands = mapListFilter({ obj: data.brands, id: `id`, value: `id`, label: `title`})
      const social = mapListFilter({ obj: data.social, id: `id`, value: `level`, label: `title`})
      const profile = mapListFilter({ obj: data.profile, id: `id`, value: `id`, label: `name`})
      this.brands = brands
      this.social = social
      this.profile = profile
      this.surroundings = fromKeys(data.surrounding)
      this.locations = data.cities

      let category = data.category
      const filter = category.map(el => {
        let label = el.name == 'airport'? `airport lounge` : el.name
        const newObj = {
          label: label,
          value: el.name,
        }
        return newObj
      })
      filter.unshift({
        label: `All`,
        value: `ALL`
      })
      this.quickFilter = filter

      this.quickFilter.sort((a, b) => {
        let orderingRule = ['spbu', 'lifestyle', 'malls', 'airport', 'airlines']
        return orderingRule.indexOf(a.value) - orderingRule.indexOf(b.value)
        })
      this.setLabelType({
        cat: this.selectedQuickFilterValue,
      })
    },
    selectedBrand(item){
      if (!this.isSubLoading){
        this.selectedBrandValue = item
        this.$nextTick(() => {
          this.loadCategory()
        });
      }
    },
    selectedSocial(item){
      if (!this.isSubLoading){
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
      }
    },
    selectedSort(item){
      if (!this.isSubLoading){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `-traffic`
      } else {
        this.selectedSortValue = item.value
      }
      }
    },
    selectedProfile(item){
      if (!this.isSubLoading){
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
      }
    },
    selectedSurrounding(item){
      if (!this.isSubLoading){
      this.selectedSurroundingValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
      }
    },
    selectedLocation(item){
      if (!this.isSubLoading){
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.loadCategory()
      });
      }
    },
    showAllClicked(item){
      this.selectedQuickFilterValue = item
    },
    setFilterQuery (query) {
      Object.keys(query).map((index, element) => {
        const variable = types.searchFilter[index]
        this.$data[variable] = ( () => {
          switch (variable) {
            case `selectedSortValue`:
            case `selectedLocationValue`:
            case `searchValue`:
            case `selectedQuickFilterValue`:
              return query[index]
              break
            default:
              if (index==`query`){
                this.$data[`searchValue`]= query[index]
              } else {
                if (query[index]) return query[index].split(`,`)
              }
          }
        })()
      })
    },
    setLabelType({ cat}) {
      this.labelType = this.quickFilter.filter( el => {
        return el.value === cat
      }).pop().label || `Type`
    },
    gotoDetail(item, list) {
      const {pub_id, media_name} = item
      const {property_type, category_display} = list
      
      let path = this.convertToUrl(property_type, media_name, category_display) + `${pub_id}`

      let route = this.$router.resolve({path: path});
      window.open(route.href, '_blank');
    },
    convertToUrl(property_type, media_name, category_display){
      if (property_type.trim() == 'IF'){
        let first_url =  `/airlines/inflight`
        let second_url = ``
          switch (media_name.toLowerCase().trim()){
            case 'aircraft wifi':
              second_url = `wifi`
              break;
            case 'aircraft livery':
              second_url = `aircraft`
              break;
            case 'avod':
              second_url = `avod`
              break;
            case 'checkin counter':
              second_url = `checkcounter`
              break;
            case 'magazine':
              second_url = `magazine`
              break;
            case 'material branding':
              second_url = `materialbranding`
              break;
            case 'screen': //office
              second_url = `office`
              break;
            case 'sampling':
              second_url = `sampling`
              break;
          }
          return `${first_url}/${second_url}/`
      } else if (property_type.trim() == 'AM') {
        let first_url = `/airlines/airport-media`
        let second_url = ``
        switch(media_name.toLowerCase().trim()){
          case 'screen':
            second_url = `lcd`
            break;
          case 'experience branding':
            second_url = `lightbox`
            break;
        }
        return `${first_url}/${second_url}/`
      } else {
        return `/${this.mediaNameUrl(media_name)}/${category_display.trim()}/`
      }
    },
    mediaNameUrl(media_name){
      if (media_name.toLowerCase().trim() == 'device'){
        return 'digital'
      } else {
        return 'experience'
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>